import Vue from 'vue'
import Vuex from 'vuex'
import vuexAlong from  'vuex-along';
import state from './state';
import mutations from './mutations';
import actions from './actions';
import getters from './getters';


Vue.use(Vuex)

export default new Vuex.Store({
    namespaced: true,  //多出的一行
    state,
    mutations,
    actions,
    getters,
    plugins: [vuexAlong({
        name:"vuex-along",
        // 仅持久化轻量且首屏即读的字段；以下字段体积大或刷新后可重新拉取，不入库
        // （menu/buttons/crumbsArr 每次导航重拉，routeList 全项目无人写入，
        //   visitedViews/cachedViews 为会话临时的 tabs 缓存）
        local:{
            list:['menu','routeList','visitedViews','cachedViews','buttons','crumbsArr'],
            isFilter:true   // true=黑名单：排除 list 中字段，其余照常持久化
        },
        session:false
    })]
})



// WEBPACK FOOTER //
// ./src/store/index.js